// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_dB8_e","notFoundContent":"notFoundContent_S4fxG","h-black-99":"h-black-99_hIKgW","homeButton":"homeButton_vBRI5"};